import Cookies from 'js-cookie';

const base = () => process.env.REACT_APP_BACKEND_ADDRESS;
const headers = () => ({ 'Authorization': 'Bearer ' + Cookies.get('token'), 'Content-Type': 'application/json' });

export async function fetchDrafts() {
    const res = await fetch(`${base()}/drafts`, { headers: headers() });
    if (!res.ok) throw new Error('Failed to fetch drafts');
    return res.json();
}

export async function createDraft(name, content) {
    const res = await fetch(`${base()}/drafts`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ name, content }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'Failed to create draft');
    }
    return res.json();
}

export async function updateDraft(id, { name, content } = {}) {
    const res = await fetch(`${base()}/drafts/${id}`, {
        method: 'PATCH', headers: headers(), body: JSON.stringify({ name, content }),
    });
    if (!res.ok) throw new Error('Failed to update draft');
    return res.json();
}

export async function deleteDraft(id) {
    const res = await fetch(`${base()}/drafts/${id}`, { method: 'DELETE', headers: headers() });
    if (!res.ok) throw new Error('Failed to delete draft');
}
